import * as moment from "moment";
import {InvoiceEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import Attachment from "../../attachment/Attachment";
import ActivityEvent from "../../event/ActivityEvent";
import InvoiceCreatedEvent from "./InvoiceCreatedEvent";
import InvoiceSentEvent from "./InvoiceSentEvent";
import InvoicePaidEvent from "./InvoicePaidEvent";
import InvoiceUpdatedEvent from "./InvoiceUpdatedEvent";

/**
 * Invoice event model.
 */
export default class InvoiceEvent extends ActivityEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {InvoiceEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 */
	constructor(public readonly id: string,
		public readonly type: InvoiceEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment) {
		super();
	}

	public static fromJson(json: InvoiceEventApiDto): InvoiceEvent {
		let type: InvoiceEventTypeEnum;
		switch (json.type) {
			case InvoiceEventTypeEnum.InvoiceCreated:
				type = InvoiceEventTypeEnum.InvoiceCreated;
				break;
			case InvoiceEventTypeEnum.InvoiceSent:
				type = InvoiceEventTypeEnum.InvoiceSent;
				break;
			case InvoiceEventTypeEnum.InvoicePaid:
				type = InvoiceEventTypeEnum.InvoicePaid;
				break;
			case InvoiceEventTypeEnum.InvoiceUpdated:
				type = InvoiceEventTypeEnum.InvoiceUpdated;
				break;
			default:
				type = InvoiceEventTypeEnum.InvoiceCreated;
		}
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new InvoiceEvent(json.id, type, creator, moment(json.creationDateTime));
	}

	getCssClass() {
		return '';
	}

	getIcon() {
		return Icon.New;
	}

	getIconColor(): IconColor {
		return IconColor.Blue;
	}

	getAttachments(): Attachment[] {
		return [];
	}

	getActivityAdditionalMessages(): string[] {
		return [];
	}

	getActivityType(): string {
		return `INVOICE`;
	}

	getCreationDate(): moment.Moment {
		return this.creationDateTime;
	}

	getId() {
		return this.id;
	}

	/**
	 * Get user display name.
	 */
	getUserDisplayName(): string {
		return this.creator.getDisplayName();
	}
}

export enum InvoiceEventTypeEnum {
	InvoiceCreated = "INVOICE_CREATED",
	InvoiceApproved = "INVOICE_APPROVED",
	InvoiceSent = "INVOICE_SENT",
	InvoicePaid = "INVOICE_PAID",
	InvoiceUpdated = "INVOICE_UPDATED",
	Note = "INVOICE_NOTE",
	Payment = "PAYMENT"
}

export type InvoiceEventType =
	InvoiceEvent
	| InvoiceCreatedEvent
	| InvoiceSentEvent
	| InvoicePaidEvent
	| InvoiceUpdatedEvent;
